import axios from 'axios';
import {ApiResponse} from '@interface/common';
import {FileInfo} from '@interface/common/File';


/** 자료실 파일 목록 (서버 file.path.dir 디렉터리) */
export const getFileList = async () => {
    const {data} = await axios.get<ApiResponse<FileInfo[]>>('/api/files/list');
    return data;
};

/** 파일 다운로드 URL. 같은 오리진의 API 를 사용하므로 도메인을 고정하지 않는다. */
export const getFileDownloadUrl = (fileName: string) => {
    return `/api/files/download?fileName=${encodeURIComponent(fileName)}`;
};
